import React from "react";
import { makeStyles, Toolbar, Button } from "@material-ui/core";
import Contato from "../assets/Icones/contato.png";
import Albuns from "../assets/Icones/galeria.png";
import Planos from "../assets/Icones/planos.png";
export default function Appbar() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.desktop}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.contentTBD}>
            <div className={classes.botoesEsquerda}>
            </div>
            <div className={classes.botoesDireita}>
              <Button className={classes.botao} href="/">
                Início
              </Button>
              <Button className={classes.botao} href="/galeria">
                Álbuns
              </Button>
              <Button className={classes.botao} href="/planos-contato/#contato">
                Contato
              </Button>
              <Button className={classes.botao} href="/planos-contato/#planos">
                Planos
              </Button>
            </div>
          </div>
        </Toolbar>
      </div>
      <div className={classes.mobile}>
        <Toolbar className={classes.toolbarM}>
          <Button className={classes.botaoM} href="/">
            <div className={classes.conteudoBM}>
              <img src={Contato} alt="Inicio" className={classes.icone} />
              Inicio
            </div>
          </Button>
          <Button className={classes.botaoM} href="/galeria">
            <div className={classes.conteudoBM}>
              <img src={Albuns} alt="Albuns" className={classes.icone} />
              Albuns
            </div>
          </Button>
          <Button className={classes.botaoM} href="/planos-contato/#contato">
            <div className={classes.conteudoBM}>
              <img src={Contato} alt="Contato" className={classes.icone} />
              Contato
            </div>
          </Button>
          <Button className={classes.botaoM} href="/planos-contato/#planos">
            <div className={classes.conteudoBM}>
              <img src={Planos} alt="Planos" className={classes.icone} />
              Planos
            </div>
          </Button>
        </Toolbar>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Karla",
    backgroundColor: theme.colors.white,
  },
  desktop: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobile: {
    zIndex: "1000",
    bottom: 0,
    position: "fixed",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  toolbar: {
    height: "70px",
    width: "100vw",
    justifyContent: "center",
    boxShadow: "0px 4px 16px #00000030",
  },
  contentTBD: {
    flex: 1,
    maxWidth: "1376px",
    paddingLeft: "5px",
    paddingRight: "5px",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
  },
  toolbarM: {
    width: "100vw",
    height: "56px",
    justifyContent: "space-evenly",
    display: "flex",
    backgroundColor: theme.colors.gray4,
    boxShadow: "0px 4px 16px #00000030",
  },
  logo: {
    height: "70px",
    width: "106px",
  },
  botao: {
    fontSize: "18px",
    color: theme.colors.gray2,
  },
  botaoM: {
    color: theme.colors.gray2,
  },
  conteudoBM: {
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  botoesDireita: {
    gap: "24px",
    display: "flex",
  },
  botoesEsquerda: {
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
    display: "flex",
  },
  espaco: {
    height: "56px",
  },
  icone: {
    height: "30px",
    width: "30px",
  },
  face: {
    height: "26.66px",
  },
  youtube: {
    height: "23.86px",
  },
  insta: {
    height: "23.86px",
  }
}));
